import { createVNode as _createVNode, withModifiers as _withModifiers, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-42af6c5c")

_pushScopeId("data-v-42af6c5c")
const _hoisted_1 = { class: "download-wrapper" }
const _hoisted_2 = { class: "download-up" }
const _hoisted_3 = /*#__PURE__*/_createVNode("span", null, "扫码下载", -1)
const _hoisted_4 = /*#__PURE__*/_createVNode("span", null, "点击下载", -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("img", {
        src: `${_ctx.rootUrl}/hotspot/final/download_qrcode.png`
      }, null, 8, ["src"]),
      _hoisted_3
    ]),
    (!_ctx.isZsApp)
      ? (_openBlock(), _createBlock("div", {
          key: 0,
          class: "download-down",
          onClick: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.goDownload && _ctx.goDownload(...args)), ["stop","prevent"]))
        }, [
          _createVNode("img", {
            src: `${_ctx.rootUrl}/hotspot/final/download_action.png`
          }, null, 8, ["src"]),
          _hoisted_4
        ]))
      : _createCommentVNode("", true)
  ]))
})